import {
    useContext,
    createContext,
    useState,
    useEffect,
    ReactNode,
} from "react";
import { PixlApp, ItemDatabase } from "@mythic/pixl";

const PixlContext = createContext<PixlProviderType | null>(null);
export const usePixl = () => {
    const ctx = useContext(PixlContext);
    if (!ctx) throw new Error("usePixl must be used inside of PixlProvider");
    return ctx;
};

export type PixlProviderType = {
    pixlApp: PixlApp | null;
    pixlDb: ItemDatabase | null;
    pixlReady: boolean;
};

interface Props {
    children: ReactNode;
}

export function PixlProvider({ children }: Props) {
    const [pixlApp, setPixlApp] = useState<PixlApp | null>(null);
    const [pixlDb, setPixlDb] = useState<ItemDatabase | null>(null);

    const [pixlReady, setPixlReady] = useState(false);

    useEffect(() => {
        const idb = new ItemDatabase(
            import.meta.env.VITE_SERVER_URL + "/data/customizationV2.json",
        );

        // once the database is loaded, enable pixl
        idb.onReady = () => {
            setPixlReady(true);
        };

        idb.fileRoot = import.meta.env.VITE_SERVER_URL;

        const app = new PixlApp(idb);

        setPixlDb(idb);
        setPixlApp(app);
    }, []);

    const value = { pixlApp, pixlDb, pixlReady };
    return (
        <PixlContext.Provider value={value}>{children}</PixlContext.Provider>
    );
}
